module.exports = __webpack_public_path__ + "static/img/qrcode.d6ccb67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nbOL/qrcode.png
// module id = f3oY
// module chunks = 1